export default __webpack_public_path__ + "static/media/list2-icon.ffeb59b3.svg";